var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketCreate" } }, [
    _c(
      "div",
      { staticClass: "dialog-content" },
      [
        _c("div", { staticClass: "context" }, [
          _vm._v(
            "Add images to this ticket. A ticket can have up to 15 images."
          )
        ]),
        _vm._v(" "),
        _c("vo-image-select", {
          ref: "imageSelect",
          attrs: { max: 15 - _vm.selected.images.length }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { flat: "", color: "info", disabled: _vm.lockout.on },
            on: {
              click: function($event) {
                _vm.routeRemoveQuery("dialog")
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { flat: "", color: "primary", loading: _vm.lockout.on },
            on: { click: _vm.addImages }
          },
          [_vm._v("Add Images")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d48af66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d48af66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketAddImages.vue
// module id = 590
// module chunks = 4